import {Component, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';
import * as moment from 'moment';

const momentObj = (moment as any);

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  public environment: any = environment;
  public year: number = 0;

  public ngOnInit(): void {
    this.year = momentObj().year();
  }
}
